let idCount = 0

const record = {}

const _scrollTo = (id, dom, value, attr) => {
  if (record[id]) {
    requestAnimationFrame(() => {
      if (dom[attr] < value) {
        dom[attr] += dom[attr] + 10 > value ? value - dom[attr] : 10
        _scrollTo(id, dom, value, attr)
      } else if (dom[attr] > value) {
        dom[attr] -= dom[attr] - 10 < value ? dom[attr] - value : 10
        _scrollTo(id, dom, value, attr)
      } else {
        delete record[id]
      }
    })
  } else {
    delete record[id]
  }
}

export const scrollTo = (dom, value, direction) => {
  idCount += 1
  const id = idCount
  record[id] = true
  const maxScroll = dom.scrollWidth - dom.offsetWidth
  const target =
    dom[direction] < value ? Math.min(maxScroll, value) : Math.max(0, value)
  _scrollTo(id, dom, target, direction)
  return id
}

export const clearScrollTo = id => {
  if (record[id]) {
    record[id] = false
  }
}
